let Errors = {
  errorDetails: function (field, error) {
    return {
      field: field,
      type: error.type,
      message: error.message,
    };
  },

  CardNumberInvalid: { type: 'CardNumberInvalid', message: 'Your card number is invalid.' },

  CvvNotSet: { type: 'CvvNotSet', message: 'Your card\'s security code is incomplete.' },

  ExpiryIsInThePast: { type: 'ExpiryIsInThePast', message: 'Your card\'s expiration date is in the past.' },
  ExpiryIsNotSet: { type: 'ExpiryIsNotSet', message: 'Your card\'s expiration date is incomplete.' },

  TokenizationValidationFailed: { type: 'TokenizationValidationFailed', message: 'Your card information is invalid or incomplete.' },
  TokenizationFailed: { type: 'TokenizationFailed', message: 'We are unable to complete your transaction at this time.' },
  TokenizationNoResponse: { type: 'TokenizationNoResponse', message: 'Your connection to our servers is timing out.' },
};

module.exports = Errors;



// WEBPACK FOOTER //
// ./app/errors.js